import React from 'react';

/**
 * Кнопка с иконкой стрелки вниз
 * @returns 
 */
export const ArrowButton: React.FC<{ state: 'up' | 'down', size?: number, opacity?: number }> = ({ state, size = 5, opacity = 100 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            className={`lucide lucide-chevron-${state} inline w-${size} h-${size} opacity-${opacity}`}>
            <path d="m6 9 6 6 6-6"></path>
        </svg>
    );
};